// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/flag.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import './styles.scss'

export class Branches extends React.Component {
  render() {
    return (
      <div className='branches' style={{ overflowY: 'hidden' }}>
        <img
          src='https://interaktiv.tagesanzeiger.ch/2017/weisse-weihnachten/branches-blank.png'
          style={{ width: '100%', position: 'relative', bottom: '-10px' }}
        />
      </div>
    )
  }
}

export default Branches
